import { fetcherPublic1819 } from "@utils/fetcherPublic1819";
import RegistrationPage from "@pages/[companySubID]";

// Company is fetched on the server
export const getServerSideProps = async (ctx) => {
    let uri = "1819/details?id=" + ctx.query.infoID + "&omit-branches=true";
    if (ctx.query.q) {
        uri += "&query=" + ctx.query.q;
    }
    let headers = {};
    if (ctx.req.headers.referer) {
        headers["referer"] = ctx.req.headers.referer;
    }
    if (ctx.req.headers["user-agent"]) {
        headers["user-agent"] = ctx.req.headers["user-agent"];
    }
    try {
        const company = await fetcherPublic1819(uri, "GET", undefined, headers);
        if (!company) {
            return { props: {} };
        }
        try {
            let regex = /(<([^>]+)>)/gi;
            company.description = company?.information?.replace(regex, "") || null;
        } catch (e) {
            console.log(e);
        }
        return { props: company };
    } catch (error) {
        console.log(error);
        return { props: {} };
    }
};

export default RegistrationPage;
